import CookieIcon from './CookieIcon'

export default CookieIcon
